export default __webpack_public_path__ + "static/media/CEM-VR.be40844f.webp";